export enum LightspeedSyncMode {
  CREATE_ONLY = 'create_only',
  CREATE_AND_UPDATE = 'create_and_update',
  UPDATE_ONLY = 'update_only',
  PRICE_AND_ACTIVE = 'price_and_active',
  PRICE_ONLY = 'price_only',
  IMAGES_ONLY = 'images_only',
  TABLES = 'tables',
}
